import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "defaultOpen", "open", "onOpenChange"];
import { jsx } from 'react/jsx-runtime';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import noop from 'lodash/noop';
import { useContext, useCallback, createContext } from 'react';
import { useControllableState } from '../../utils/useControllableState.js';
import { SubMenuMenuProvider } from '../menu-utils/responsiveness/SubMenuContext.js';
var ResponsiveSubmenuContext = /*#__PURE__*/createContext({
  open: false,
  setOpen: noop
});

var useResponsiveSubmenuContext = function useResponsiveSubmenuContext() {
  return useContext(ResponsiveSubmenuContext);
};
/**
 * Based on Radix-UI Sub
 * @see https://www.radix-ui.com/docs/primitives/components/dropdown-menu#sub
 */


var DropdownMenuSubMenuRoot = function DropdownMenuSubMenuRoot(props) {
  var children = props.children,
      defaultOpen = props.defaultOpen,
      open = props.open,
      onOpenChange = props.onOpenChange,
      rest = _objectWithoutProperties(props, _excluded);

  var _useControllableState = useControllableState({
    prop: open,
    onChange: onOpenChange,
    defaultProp: defaultOpen
  }),
      _useControllableState2 = _slicedToArray(_useControllableState, 2),
      _useControllableState3 = _useControllableState2[0],
      isSubMenuOpen = _useControllableState3 === void 0 ? false : _useControllableState3,
      setIsSubMenuOpen = _useControllableState2[1];

  var handleOpenChange = useCallback(function (value) {
    setIsSubMenuOpen(value);
  }, [setIsSubMenuOpen]);
  return jsx(SubMenuMenuProvider, {
    isSubMenuOpen: isSubMenuOpen,
    setIsSubMenuOpen: setIsSubMenuOpen,
    children: jsx(DropdownMenuPrimitive.Sub, _objectSpread(_objectSpread({}, rest), {}, {
      onOpenChange: handleOpenChange,
      open: isSubMenuOpen,
      children: children
    }))
  });
};

DropdownMenuSubMenuRoot.displayName = 'DropdownMenuSubMenuRoot';
export { DropdownMenuSubMenuRoot, useResponsiveSubmenuContext };